import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import react, { useEffect } from "react";
import { Box, Button, Dialog, FilterChip, Flex, Relative, Text } from "pcln-design-system";
import analytics from "../analytics/analytics.js";
import { useChatMessagesContext } from "../hooks/useChatMessagesContext.js";
const amenitiesMap = {
    HEALTHSVCS: 'Health Services',
    HANDFAC: 'Handicap-accessible Facilities',
    FAMFRIEND: 'Family Friendly',
    FPRKING: 'Free Parking',
    FINTRNT: 'Free Internet',
    NSMKFAC: 'Non-smoking Facilities',
    SPOOL: 'Swimming Pool',
    SUSTAIN: 'Sustainable Practices',
    KIDFRIEND: 'Kid Friendly',
    PETALLOW: 'Pets Allowed',
    RESTRNT: 'Restaurant',
    FBRKFST: 'Free Breakfast',
    FITSPA: 'Fitness Center',
    HOTTUB: 'Hot Tub',
    SPA: 'Spa Services',
    BUSCNTR: 'Business Center',
    SPOOLOUT: 'Outdoor Swimming Pool',
    FINTRRM: 'Free In-room Internet',
    FINTRPUB: 'Free Public Internet',
    KITCHEN: 'Kitchen Facilities',
    BCHFRNT: 'Beachfront Location',
    CASINO: 'Casino',
    FAIRSHUTTL: 'Airport Shuttle (fee)',
    AIRSHUTTL: 'Airport Shuttle',
    SPOOLIN: 'Indoor Swimming Pool',
    ADULTONLY: 'Adult Only Property',
    FINTRAVL: 'Free Internet in Common Areas',
    INCLUSIVE: 'All-Inclusive Option'
};
const formatFilterList = (filters = [])=>{
    if (0 === filters.length) return '';
    {
        if (1 === filters.length) return filters[0];
        const lastFilter = filters.pop();
        return `${filters.join(', ')}, and ${lastFilter}`;
    }
};
const HotelFilterComponent = (props)=>{
    const [isOpen, setIsOpen] = react.useState(false);
    const [selectedAmenities, setSelectedAmenities] = react.useState({});
    const [prevSelectedAmenities, setPrevSelectedAmenities] = react.useState({});
    const searchUrl = props?.clientRedirectUrl || '';
    const amenities = props?.args?.amenities || '';
    const { chatMessages } = useChatMessagesContext();
    useEffect(()=>{
        const prevSelected = amenities?.split(',').reduce((res, key)=>{
            res[key] = true;
            return res;
        }, {});
        setSelectedAmenities(prevSelected);
        setPrevSelectedAmenities(prevSelected);
    }, [
        amenities
    ]);
    const { setChatMessages, submitMessages, searchResult, hasSopqHotel, hasRtlHotel, toggleOnlyExpressDealClick, displaySopqOnly } = props;
    const { tripFilterSummary, totalSize } = searchResult;
    const hotelCount = tripFilterSummary?.totalSizeFiltered || totalSize;
    const onFilterClick = function() {
        analytics.log({
            label: 'HotelSearchResult',
            message: 'ALL_HOTEL_FILTERS_LINK_CLICKED',
            ...props?.args
        });
        setIsOpen(true);
    };
    const onAllResultsLinkClick = function() {
        analytics.log({
            label: 'HotelSearchResult',
            message: 'ALL_HOTEL_RESULTS_LINK_CLICKED',
            searchUrl,
            ...props?.args
        });
        window.open(searchUrl, '_blank');
    };
    const { amenityCounts } = props.searchResult?.tripFilterSummary || {};
    return /*#__PURE__*/ jsx(Relative, {
        top: '5px',
        children: /*#__PURE__*/ jsxs(Flex, {
            alignItems: "center",
            ml: 3,
            mb: 4,
            children: [
                amenityCounts ? /*#__PURE__*/ jsx(Button, {
                    variation: "subtle",
                    onClick: onFilterClick,
                    mr: 2,
                    size: "small",
                    children: "Filter Options"
                }) : null,
                hasSopqHotel && hasRtlHotel && /*#__PURE__*/ jsx(Button, {
                    variation: "subtle",
                    onClick: toggleOnlyExpressDealClick,
                    mr: 2,
                    size: "small",
                    children: displaySopqOnly ? 'Show Deals' : 'Show Express Deals Only'
                }),
                searchUrl && hotelCount ? /*#__PURE__*/ jsxs(Button, {
                    variation: "subtle",
                    onClick: onAllResultsLinkClick,
                    size: "small",
                    children: [
                        "View ",
                        hotelCount,
                        " Results"
                    ]
                }) : null,
                /*#__PURE__*/ jsx(Dialog, {
                    zIndex: 1000,
                    showCloseButton: true,
                    scrimDismiss: false,
                    open: isOpen,
                    size: "md",
                    onOpenChange: function(isOpen) {
                        if (!isOpen) setIsOpen(false);
                    },
                    borderRadius: 'xl',
                    ariaDescription: "Dialog to filter hotels",
                    ariaTitle: "Filter hotels",
                    scrimColor: "dark",
                    headerContent: /*#__PURE__*/ jsx(Text, {
                        children: "Available Hotel Filter Options"
                    }),
                    children: /*#__PURE__*/ jsxs(Box, {
                        p: 4,
                        children: [
                            amenityCounts ? /*#__PURE__*/ jsx(Fragment, {
                                children: Object.keys(amenityCounts).map((key, i)=>{
                                    const counts = amenityCounts[key];
                                    const isSelected = Boolean(selectedAmenities?.[key]);
                                    const name = `chip-${key}-${i}`;
                                    return /*#__PURE__*/ jsx(FilterChip, {
                                        name: name,
                                        m: 1,
                                        selected: isSelected,
                                        label: `${amenitiesMap?.[key] || key} (${counts})`,
                                        showActionIcon: isSelected,
                                        disabled: 0 === Number(counts),
                                        onClick: function() {
                                            setSelectedAmenities({
                                                ...selectedAmenities,
                                                [key]: !isSelected
                                            });
                                        }
                                    }, name);
                                })
                            }) : null,
                            /*#__PURE__*/ jsxs(Box, {
                                children: [
                                    /*#__PURE__*/ jsx("br", {}),
                                    /*#__PURE__*/ jsx(Button, {
                                        onClick: function(event) {
                                            event.preventDefault();
                                            const { addedFilters, removedFilters } = Object.keys(selectedAmenities).reduce((acc, key)=>{
                                                const amenityName = amenitiesMap?.[key] || key;
                                                if (selectedAmenities[key] && !prevSelectedAmenities[key]) acc.addedFilters.push(amenityName);
                                                if (!selectedAmenities[key] && prevSelectedAmenities[key]) acc.removedFilters.push(amenityName);
                                                return acc;
                                            }, {
                                                addedFilters: [],
                                                removedFilters: []
                                            });
                                            let content = '';
                                            if (addedFilters.length > 0) content += `Added the following filters: ${formatFilterList(addedFilters)}. `;
                                            if (removedFilters.length > 0) content += `Removed the following filters: ${formatFilterList(removedFilters)}.`;
                                            const promptMessage = {
                                                role: 'user',
                                                content: content
                                            };
                                            analytics.log({
                                                label: 'HotelSearchResult',
                                                message: 'APPLY_HOTEL_FILTERS_CLICKED',
                                                addedFilterOptions: addedFilters.join(',') || 'none',
                                                removedFilterOptions: addedFilters.join(', ') || 'none',
                                                ...props?.args
                                            });
                                            const displayMessage = {
                                                ...promptMessage,
                                                date: new Date()
                                            };
                                            setChatMessages([
                                                ...chatMessages,
                                                displayMessage
                                            ]);
                                            submitMessages(promptMessage);
                                            setIsOpen(false);
                                        },
                                        children: "Apply Filters"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export { HotelFilterComponent, amenitiesMap };
